<template>
     <vs-dialog prevent-close v-model="active" width="800px">
        <template #header>
          <h4 class="not-margin">
              Editar área
          </h4>
        </template>
        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">Nombre</label>
                    <vs-input class="pt-0" v-model="nombre" placeholder="Nombre">
                        <template #message-danger v-if="errorFields.includes('nombre')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">Grado</label>
                    <vs-select
                        filter
                        class="pt-0"
                        placeholder="Grado"
                        v-model="grado"
                        :key="gradoId"
                    >
                        <template #message-danger v-if="errorFields.includes('grado')">
                            Requerido
                        </template>
                        <vs-option v-for="(opcion, j) in grados" :key="j" :label="opcion.text" :value="opcion.id">
                            {{opcion.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
            </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="limpiarInfo()">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="postEditarArea()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
      'value',
      'selectArea',
      'programa',
      'areaId'
    ],
    data () {
        return {
            active: false,
            grados: [],
            gradoId:  (new Date()).getTime(),
            grado: '',
            nombre: '',
            errorFields: []
        }
    },
    methods: {
        async getGrado(){
            try{
                const response = await academico.getGrado(this.programa)
                this.grados = response.data
                this.gradoId = (new Date()).getTime()
            } catch (error) {
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.grado) {
                this.errorFields.push('grado')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postEditarArea(){
            if(this.sanityForm){
                const loading = this.$vs.loading()
                try{
                    const params = {
                        asignaturas: this.selectArea.asignaturas,
                        created_at: this.selectArea.created_at,
                        grado_id: this.grado,
                        id: this.selectArea.id,
                        nombre: this.nombre,
                        plan_estudios_id: this.selectArea.plan_estudios_id,
                        updated_at: this.selectArea.updated_at
                    }
                    const response = await academico.postEditarArea(this.selectArea.id, params)
                    loading.close()
                    this.active = false
                    this.$vs.notification({
                        sticky: true,
                        color: 'success',
                        position: null,
                        title: 'Se a creado con éxito la asignatura'
                    })
                    this.$emit('refreshTable')
                } catch (error) {
                    loading.close()
                    console.log(error)
                    this.$vs.notification({
                    color: 'danger',
                    position: null,
                    title: 'Algo salio mal, favor de contactar al administrador '
                    })
                }
            } 
        },
        getInfo(){
            this.nombre = this.selectArea.nombre ? this.selectArea.nombre : ''
            this.grado = this.selectArea.grado_id ? this.selectArea.grado_id : ''
        }
     },
    watch: {
        value (val) {
            this.active = val
            this.getGrado()
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        selectArea(){
            this.getInfo()
        }
    }
}
</script>
<style scoped>
label{
    font-size: 0.75rem;
}
</style>